import { useQuery } from '@tanstack/react-query'
import { assinaturaApi } from '../../api/endpoints'

/** Grupos, lista de compras e insights da nota valem para quem tem notas fiscais no plano (Premium em diante). */
export function usePermiteNotas() {
  const { data, isLoading } = useQuery({ queryKey: ['assinatura'], queryFn: assinaturaApi.minha, staleTime: 60_000 })
  // Sem a assinatura carregada ou se a consulta falhar, deixa passar: a API é quem barra de verdade.
  return { carregando: isLoading, permite: data ? data.plano.permiteNotasFiscais : true }
}
